export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20composition%20with%20soft%20cream%20and%20beige%20tones%2C%20delicate%20geometric%20shapes%20floating%20in%20gentle%20ambient%20light%2C%20organic%20curves%20blending%20into%20clean%20modern%20forms%2C%20subtle%20product%20silhouettes%20in%20background%2C%20artistic%20editorial%20photography%20with%20soft%20shadows%2C%20European%20contemporary%20aesthetic%2C%20serene%20and%20sophisticated%20atmosphere%2C%20no%20harsh%20colors%2C%20warm%20neutral%20palette&width=1600&height=900&seq=hero-main-bg-2026&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          Kakobuy Spreadsheet Polska &mdash;<br />
          <span className="text-accent-400">Znajdź najlepsze produkty z Chin</span> w kilka minut
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Kompletna baza Kakobuy Spreadsheet z najlepszymi produktami,
          kategoriami, poradnikami oraz wskazówkami bezpieczeństwa
          dla polskich użytkowników.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-fire-line text-lg"></i>
            Sprawdź najnowszy Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-base font-semibold hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-check-line', text: 'Aktualizowane listy produktów' },
            { icon: 'ri-check-line', text: 'Kategorie Sneakers & Fashion' },
            { icon: 'ri-check-line', text: 'Poradniki dla początkujących' },
            { icon: 'ri-check-line', text: 'Bezpieczne zakupy' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-white/90 text-sm">
              <i className={`${item.icon} text-accent-400 text-base`}></i>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}